<template>
  <aside-modal v-slot="{ close }" v-model="bcLinkStore.showModal">
    <form n:name="copyForm" class="flex flex-col h-full --FormErrors">
      <div>
        <div class="bg-bc-blue text-white px-6 py-5 rounded-tl-md">
          <div class="flex items-center mb-2">
            <div class="text-lg flex-1">{{ $t('Edit link') }}</div>
            <div>
              <aw-icon icon="close" class="w-6 h-6 current-fill text-white cursor-pointer -mr-1.5 -mt-2" @click="closeModal(close)" />
            </div>
          </div>
        </div>
      </div>
      <!-- CONTENT NOT STICKY, OVERFLOWED IF NEEDED -->
      <div
        class="py-5 px-6 space-y-4 overflow-y-auto flex-1 relative flex flex-col"
      >
        <div>
          <div class="flex flex-wrap items-center space-y-3 py-3">
            <nav 
              class="-mb-px flex flex-1" 
              aria-label="Tabs"
            >
              <tab-panel-pill
                v-for="(item, index) in tabs"
                :key="index"
                @click.stop.prevent="changeModel(item.action)"
                :active="item.action === bcLinkStore.type"
                :icon="item.icon"
                :text="$t(item.text)"
                class="pill__Tab-white"
              />
            </nav>
          </div>
        </div>

        <div class="flex-grow overflow-y-auto" v-if="bcLinkStore.type === 'external'">
          <div class="grid grid-cols-1 gap-y-6 gap-x-4 sm:grid-cols-6">
            <div class="sm:col-span-6 form-group">
              <label for="frm-linkForm-link" class="block text-sm font-medium">{{ $t('Url') }}</label>
              <div class="mt-1 flex rounded-md shadow-sm">
                <input id="frm-linkForm-link" class="form-control" v-model="bcLinkStore.url" />
              </div>
            </div>
            <!--
            <div class="sm:col-span-6 form-group">
              <toggle-button class="flex items-center cursor-pointer" v-model="bcLinkStore.openInNewWindow">
                <span class="ml-2.5 text-sm">
                  {{ $t('Open in a new tab') }}
                </span>
              </toggle-button>
            </div>
            -->
          </div>
        </div>

        <template v-else>
        <div>
          <div class="block text-sm font-medium">{{ $t('Link to:') }}</div>
          <div class="mt-1 flex rounded-md shadow-sm">
            <div class="form-control">
              {{ selectedItem ? selectedItemPath : '&nbsp;' }}
            </div>
          </div>
        </div>

        <div class="flex-grow overflow-y-auto">
            <move-copy-nav selected-action="link" :bc-id="$presenter.bcId" />
        </div>
        </template>
      </div>
      <!-- STICKY FOOTER - SUBMIT BUTTONS ALMOST -->
      <div class="flex-shrink-0 p-5 border-t border-gray-400">
        <div class="flex justify-end">
          <button type="button" class="btn btn-white" @click.stop.prevent="closeModal(close)">
            <aw-icon
                icon="close"
                class="w-5 h-5 "
            />
            {{ $t('Cancel') }}
          </button>
          <button
            type="button"
            class="ml-3 btn"
            :class="{ 'btn-primary': isValid }"
            :disabled="!isValid"
            @click.stop.prevent="save(close)"
          >
            <aw-icon
                icon="link"
                class="w-5 h-5 "
            />
            {{ $t('Save') }}
          </button>
        </div>
      </div>
    </form>
  </aside-modal>
</template>
<script>
import { mapStores } from 'pinia'
import useBcLinkStore from '@/frontapp/store/bcLink'
import bcMoveCopyStore from '@/frontapp/store/bcMoveCopy'

export default {
  data() {
    return {
      tabs: [
        {
          action: 'external',
          icon: 'external',
          text: 'External'
        },
        {
          action: 'internal',
          icon: 'link',
          text: 'Internal'
        }
      ]
    }
  },
  computed: {
    ...mapStores(useBcLinkStore, bcMoveCopyStore),
    isValid() {
      return (this.bcLinkStore.type === 'external' && this.bcLinkStore.url)
        || (this.bcLinkStore.type === 'internal' && this.bcLinkStore.url)
    },
    selectedItem() {
      return this.bcMoveCopyStore.selectedItem
    },
    selectedItemPath() {
      if (this.selectedItem) {
        // parent polozky
        const parents = []

        if (this.selectedItem.type !== 'domain') {
          parents.push(this.bcMoveCopyStore.selectedDomain.name)

          this.bcMoveCopyStore
            .listParents(this.selectedItem.type === 'folder' ? this.selectedItem.id : this.selectedItem.bc_folder_id)
            .forEach((item) => parents.push(item.name))

          // add last parent folder before document
          if (this.selectedItem.type === 'document' && this.selectedItem.bc_folder_id) {
            parents.push(this.bcMoveCopyStore.hashTable[this.selectedItem.bc_folder_id].name)
          }
        }

        // vybrana polozka = aktualni
        parents.push(this.selectedItem.name)

        return parents.join(' / ')
      }
      return null
    },
  },
  methods: {
    closeModal (close) {
      this.bcLinkStore.link = null
      this.bcLinkStore.openInNewWindow = true
      this.bcLinkStore.type = 'external'
      close()
    },
    changeModel(type) {
      this.bcLinkStore.type = type
    },
    save(close) {
      this.bcLinkStore.save()
      close()
    }
  },
  watch: {
    selectedItem(item) {
      if (item) {
        this.bcLinkStore.url = item.url
      } else {
        this.bcLinkStore.url = null
      }
    }
  }
}
</script>